import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import {IAngularMyDpOptions, IMyDateModel} from 'angular-mydatepicker';
import { SharedService } from '../../shared.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-create-customer',
  templateUrl: './create-customer.component.html',
  styleUrls: ['./create-customer.component.css']
})
export class CreateCustomerComponent implements OnInit {

  myOptions: IAngularMyDpOptions = {
    dateRange: false,
    dateFormat: 'dd.mm.yyyy'
  };

  project:any;
  cost:any;

  leads: any;
  leadDetails:any
  searchString: any = '';
  sortby: any = 'pltNo';
  pids =[] as any;

  toggle = true;

  leadForm: FormGroup;
  id: any;
  channelPartners= [] as any;
  subBrokers:any;
  currentUser:any;

  counter = 1;
  step1 = true;
  step2 = false;
  step3 = false;

  selectedProperty=' Select a Property First'

  constructor(
    private SharedService: SharedService,
    private _formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {

    this.counter = 1;
    this.step1 = true;
    this.step2 = false;
    this.step3 = false;
    this.pids = [];
    this.channelPartners = [];

    this.currentUser = this.SharedService.getUser();
    this.project = this.SharedService.getProject();


    this.SharedService.assetsList().subscribe((response:any) => {
      // console.log(response);
      response.data.forEach(element => {
        if(element.status === "available"){
          this.pids.push(element)
        }
      });
    });

    this.leadForm = this._formBuilder.group({
      name: ['', [Validators.required]],
      contact_1: ['', [Validators.required]],
      contact_2: [''],
      email: ['', [Validators.required]],
      job: [''],
      aadhar_no:['',[Validators.required]],
      pan_no:['',[Validators.required]],
      address: ['', [Validators.required]],
      source: ['walk-in',[Validators.required]],
      channel_partner: [null],
      sub_broker: [null],
      notes: [''],
      pid: ['', [Validators.required]],
      property:[''],
      inventory:[''],
      inventory_price:[''],
      plc: this._formBuilder.array([this.addPlcGroup()]),
      base_price: [''],
      property_cost: ['',[Validators.required]],
      edc: [''],
      gst: ['12'],
      emi_ammount: [''],
      remaining_balance:[''],
      payment_plan: ['clp',[Validators.required]],
      first_payment_date: [,[Validators.required]],
      payment_date: ['1',[Validators.required]],
      payment_tenure: ['2',[Validators.required]],
      sale_person:[this.currentUser._id]
    });

    this.SharedService.getDelaers().subscribe((data:any)=>{
      data.data.forEach(element => {
        if(element.status === 'active'){
          this.channelPartners.push(element)
        }
      });
      // console.log(this.channelPartners);
    })


  }

  setTenure(){
    this.leadForm.patchValue({payment_tenure: 2})
  }

  addPlcGroup(){
    return this._formBuilder.group({
      plc_name: [],
      price: []
    })
  }

  get plcArray(){
    return <FormArray>this.leadForm.get('plc')
  }

  addPlc(){
    this.plcArray.push(this.addPlcGroup())
  }

  removePlc(index:any){
    this.plcArray.removeAt(index);
  }

  setExistingPlc(plcs): FormArray{
    const formArray = new FormArray([]);
    plcs.forEach(plc => {
      formArray.push(this._formBuilder.group({
        plc_name: plc.plc_name,
        price: plc.price
      }))
    });
    return formArray
  }

  getSubBrokers(cpid:any){
    console.log(cpid);
    this.SharedService.getSubdelaers(cpid).subscribe((data:any)=>{
      this.subBrokers = data.data;
    })
  }

  pselect(pid){
    console.log(pid)
    this.pids.forEach(property => {
      if(property.pid === pid){
        // console.log(property);
        this.selectedProperty = property.type;
        this.id = property.id;
        this.leadForm.setControl('plc', this.setExistingPlc(property.plc));
        this.leadForm.patchValue({
          inventory: property.inventory,
          inventory_price: property.inventory_price,
          base_price: property?.base_price,
          edc: property?.edc
        })
      }

    });
  }

  next(){
    if(this.counter <3){
      this.leadForm.patchValue({emi_ammount: this.leadForm.get('property_cost').value})
      this.counter ++;
    }
  }
  back(){
    if(this.counter >1){
      this.counter --;
    }
  }

  onSubmit(): any {
    if (this.leadForm.invalid) {
      alert('Please fill all the required field');
      return
    } else {
      // console.log(this.leadForm.value.first_payment_date.singleDate.date.day)
      this.leadForm.patchValue({payment_date: this.leadForm.value.first_payment_date.singleDate.date.day})
      this.leadForm.patchValue({first_payment_date:this.leadForm.value.first_payment_date.singleDate.jsDate});
      this.leadForm.patchValue({remaining_balance:this.leadForm.value.property_cost});
      console.log(this.leadForm.value);
      this.SharedService.createCustomer(this.id,this.leadForm.value).subscribe((response) => {
        console.log(response);
        this.toggle = false;
        this.router.navigate(['dashboard/sales/customers']);
        this.ngOnInit();
      },
        (error) => {
          console.log(error);
          alert(error.error.message)
        })
    }
  }

  delete(user: any): any {

      Swal.fire({
        title: 'Are you sure?',
        text: 'Do you really want to delete user ' + user.name,
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.value) {
          if(user.status.toLowerCase() === user.property?.status.toLowerCase()){
            alert("Cannot Delete as Customer hold's a property")
          }else{
            this.SharedService.deleteCustomer(user._id).subscribe(response => {
              console.log(response)
              this.Toast.fire({
                title: 'Deleted!',
                text: 'The user has been deleted',
                icon: 'success'
              })
              this.ngOnInit();
            },
            (error)=>{
              console.log(error);
              this.Toast.fire({
                title: 'Error!',
                text: error.error,
                icon: 'error',
              });
            })
          }

        }
      })

  }

  Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

}
